export const iconFontAwesomeMediaplaybackRotateLeft = (
	<i className="fa-solid fa-rotate-left"></i>
);
